import './select-interview-type.modal.scss';

export default function SelectInterviewTypeModal($scope, $t, close, $alert) {
  'ngInject';

  $scope.interview = {type: null};

  $scope.close = () => {
    close();
  };

  $scope.ok = () => {
    if (!$scope.interview.type) {
      $alert.error($t('shared.modals.select_interview_type.interview_type_required_error_message'));
      return;
    }

    close($scope.interview.type);
  };

}